import Vue from 'vue'
import Router from 'vue-router'
import { isUserAuthenticated } from '@/services/auth'
import AdminPage from '@/components/admin/AdminPage'
import UserAdmin from '@/components/admin/users/UserAdmin'
import UserAddEdit from '@/components/admin/users/UserAddEdit'
import Location from '@/components/admin/location/Location'
import FareAddEdit from '@/components/admin/fare/FareAddEdit'
import Drivers from '@/components/admin/driver/Drivers'
import Vehicle from '@/components/admin/vehicle/Vehicles'
import VehicleAddEdit from '@/components/admin/vehicle/VehicleAddEdit'
import Fares from '@/components/admin/fare/Fare'
import Home from '@/components/home/Home'
import Checkout from '@/components/checkout/Checkout'
import Profile from '@/components/profile/Profile'
import PrintPage from '@/components/checkout/Print'
import Trips from '@/components/trips/Trips'
import Auth from '@/components/auth/Auth'
import TransactionsAdminPage from '@/components/transactions/TransactionsAdminPage'
import Passengers from '@/components/admin/passengers/Passengers'
import InjectFailedPassenger from '@/components/admin/passengers/InjectFailedPassenger'
import BusSelection from '@/components/home/BusSelection'
import TripManifest from '@/components/trips/TripManifest'
import RegisterPassenger from '@/components/trips/RegisterPassenger'
import Checkin from '@/components/checkin/Checkin'
import AdminMobileMenu from '@/components/AdminMobileMenu'
import OfflinePassenger from '@/components/admin/passengers/create/OfflinePassenger'
import ReportManager from '@/components/admin/reporting/ReportManager'
import TermsAndConditions from '@/components/terms/TermsAndConditions'

Vue.use(Router)

const metaConfig = (props) => ({
  meta: {
    ...props
  }
})

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout
    },
    {
      path: '/checkin',
      name: 'Checkin',
      component: Checkin
    },
    {
      path: '/print',
      name: 'PrintPage',
      component: PrintPage
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: { requiredAuth: false }
    },
    {
      path: '/bus-selection',
      name: 'BusSelection',
      component: BusSelection
    },
    {
      path: '/auth',
      name: 'Auth',
      alias: ['/login', '/signup'],
      component: Auth
    },
    {
      path: '/terms-and-condition',
      name: 'TermsAndConditions',
      component: TermsAndConditions
    },
    {
      path: '/admin',
      name: 'Admin',
      component: AdminPage,
      meta: {
        is_staff: false,
        is_superuser: false,
        requiredAdmin: false,
        requiredAuth: false,
        title: 'Admin'
      },
      children: [
        {
          path: 'mobile',
          name: 'MobileMenu',
          component: AdminMobileMenu,
          ...metaConfig({
            allowAccess: true,
            roles: ['sales_rep', 'admin']
          })
        },
        {
          path: 'users',
          component: UserAdmin,
          name: 'UserAdmin'
        },
        {
          alias: 'users/edit/:id',
          path: 'users/add',
          component: UserAddEdit,
          name: 'UserAddEdit'
        },
        {
          path: 'locations',
          component: Location,
          name: 'Location'
        },
        {
          path: 'fares',
          component: Fares,
          name: 'Fares'
        },
        {
          path: 'trips',
          name: 'Trips',
          component: Trips,
          ...metaConfig({
            allowAccess: true,
            roles: ['sales_rep', 'admin']
          })
        },
        {
          path: 'trips/manifest',
          component: TripManifest,
          name: 'TripManifest',
          ...metaConfig({
            allowAccess: true,
            roles: ['sales_rep', 'admin']
          })
        },

        {
          path: 'trips/manifest/update/:id',
          component: TripManifest,
          name: 'TripManifestUpdate',
          ...metaConfig({
            allowAccess: true,
            title: 'Trip Summary Update',
            roles: ['sales_rep', 'admin']
          })
        },
        {
          path: 'trips/:id/register-passenger',
          component: RegisterPassenger,
          name: 'RegisterPassenger',
          ...metaConfig({ allowAccess: true })
        },
        {
          path: 'fare/add',
          component: FareAddEdit,
          name: 'FareAdd'
        },
        {
          component: FareAddEdit,
          path: 'fare/edit/:id',
          name: 'FareEdit'

        },
        {
          path: 'drivers',
          component: Drivers,
          name: 'Drivers'
        },
        {
          path: 'reports',
          component: ReportManager,
          name: 'ReportManager'
        },
        {
          path: 'vehicle',
          component: Vehicle,
          name: 'Vehicles'
        },
        {
          path: 'vehicle/add',
          component: VehicleAddEdit,
          name: 'VehicleAddEdit',
          meta: {

          }
        },
        {
          path: 'vehicle/edit/:id',
          component: VehicleAddEdit,
          name: 'VehicleEdit'
        },
        {
          path: 'passengers',
          component: Passengers,
          name: 'Passengers'
        },
        {
          path: '',
          component: Passengers,
          name: 'Passengers'
        },
        {
          path: 'transactions',
          name: 'Transactions',
          component: TransactionsAdminPage
        },
        {
          path: 'inject-passenger',
          component: InjectFailedPassenger,
          name: 'InjectPassenger'
        },
        {
          path: 'offline-passenger',
          component: OfflinePassenger,
          name: 'CreateOfflinePassenger',
          ...metaConfig({
            allowAccess: true,
            roles: ['sales_rep', 'admin']
          })
        }

      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => (record.meta.requiredAdmin || record.meta.requiredAuth))) {
    isUserAuthenticated(to.matched).then((response) => {
      next()
    }).catch(() => {
      router.push('/login')
    })
  } else {
    // not protected always call next to navigate to the page
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js